import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia';
import TUIRoomCore from '../../tui-room-core';
import SvgIcon from '../common/SvgIcon.vue';
import { UserInfo, useRoomStore } from '../../../stores/room';
import { useBasicStore } from '../../../stores/basic';
import { ICON_NAME } from '../../../constants/icon';
import MemberItem from './MemberItem/index.vue';
import { UserRoles } from '@/constants/render';
import { ref,computed, onMounted, Ref, watch } from 'vue-demi';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const basicStore = useBasicStore();
const roomStore = useRoomStore();

const { userList, userNumber, applyToAnchorList,remoteUserObj } = storeToRefs(roomStore);
const { userRole } = storeToRefs(basicStore);

const insertSort = function( arr :any) {
  let len = arr.length;
  var majorArr:any = [], startvArr:any = [], watchArr:any = [];
  for( var i = 0; i < len; i ++){
    if (arr[i].userId.indexOf('major') != -1){
      majorArr.push(arr[i]);
    }
    if (arr[i].userId.indexOf('startv') != -1){
      startvArr.push(arr[i]);
    }
    if (arr[i].userId.indexOf('watch') != -1){
      watchArr.push(arr[i]);
    }
  }
  return [...majorArr, ...startvArr, ...watchArr];
}
// let userRoleLsit = insertSort(userList.value);
const arrList: Ref<UserInfo[]> = ref(insertSort(userList.value))
const search=ref('')

watch(search, (val) => {
  if (val.trim()) {
    arrList.value = userList.value.filter(e => e.userName.includes(val.trim()))
  } else {
    arrList.value = userList.value
  }
})

watch(userList, (val, oldValue) => {
  console.log(val)
  console.log(oldValue)
  const addedUsers = val.filter(v => !oldValue.includes(v) && (search.value.trim().length === 0 || (search.value.trim().length > 0 && v.userName.includes(search.value.trim()))))
  const deletedUsers = oldValue.filter(v => !val.includes(v))
  console.log(deletedUsers)
  if (addedUsers) {
    arrList.value.push(...addedUsers)
  }
  if (deletedUsers) {
    arrList.value = arrList.value.filter(v => !deletedUsers.includes(v))
  }
})



function showApplyUserLit() {
  basicStore.setShowApplyUserList(true);
}

async function toggleAllAudio() {
  const newIsMuteAllAudio = !basicStore.isMuteAllAudio;
  basicStore.setIsMuteAllAudio(newIsMuteAllAudio);
  roomStore.setMuteAllAudio(newIsMuteAllAudio);
  await TUIRoomCore.muteAllUsersMicrophone(newIsMuteAllAudio);
}

async function toggleAllVideo() {
  const newIsMuteAllVideo = !basicStore.isMuteAllVideo;
  basicStore.setIsMuteAllVideo(newIsMuteAllVideo);
  roomStore.setMuteAllVideo(newIsMuteAllVideo);
  await TUIRoomCore.muteAllUsersCamera(newIsMuteAllVideo);
}



return { __sfc: true,basicStore, roomStore, userList, userNumber, applyToAnchorList, remoteUserObj, userRole, insertSort, arrList, search, showApplyUserLit, toggleAllAudio, toggleAllVideo, SvgIcon, ICON_NAME, MemberItem, UserRoles }
}

})